(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('InvitationService', InvitationService);

    InvitationService.$inject = ['$resource','$q', 'halClient', '$http', 'DateUtils', '$uibModal'];

    function InvitationService($resource, $q, halClient, $http, DateUtils, $uibModal) {
        var baseUrl = 'api/invitations';
        var resourceUrl = "api/invitations/:id";
        var service = $resource(resourceUrl, {}, {});
        service.resendHAQ = resendHAQ;
        service.resendNPQ = resendNPQ;
        service.resendPsychIntakeForm = resendPsychIntakeForm;
        service.resendPatientAgreement = resendPatientAgreement;
        service.findBySecretKey = findBySecretKey;
        service.openWarningMissingEmailPhone = openWarningMissingEmailPhone;
        service.openResendInvitationDialog = openResendInvitationDialog;

        function findBySecretKey(secretKey) {
            return $http.get(baseUrl, { params: { secretKey: secretKey }}).then(function (response) {
                return response;
            });
        };

        function resendHAQ(surveyResultId) {
            return $http.get(baseUrl + '/re-send-haq', { params: { surveyResultId: surveyResultId }}).then(function (response) {
                return response.data;
            });
        };

        function resendNPQ(nPQQuestionnaireId) {
            return $http.get(baseUrl + '/re-send-npq', { params: { nPQQuestionnaireId: nPQQuestionnaireId }}).then(function (response) {
                return response.data;
            });
        };

        function resendPsychIntakeForm(formId) {
            return $http.get(baseUrl + '/re-send-psych', { params: { formId: formId }}).then(function (response) {
                return response.data;
            });
        };

        function resendPatientAgreement(formId) {
            return $http.get(baseUrl + '/re-send-patient-agreement', {params: {formId: formId}}).then(function (response) {
                return response.data;
            });
        };

        function openWarningMissingEmailPhone() {
            $uibModal.open({
                templateUrl: 'app/shared/error-dialog/error-dialog.controller.html',
                controller: 'ErrorDialogController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'absolute-center',
                backdrop: 'static',
                resolve: {
                    isTranslate: function () {return true},
                    message: function () {return "ipmApp.patient.resendInvitation.missing_email_phone"},
                    title: function () {return "ipmApp.patient.patientCase.warning"}
                }
            }).result.then(function() {
            });
        }

        function openResendInvitationDialog() {
            $uibModal.open({
                templateUrl: 'app/patient/resend-invitation-dialog.html',
                controller: 'ResendInvitationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                windowClass: 'absolute-center vertical-center'
            }).result.then(function() {});
        }

        return service;

    }
})();
